import {canBulkDispatch, correctionRequired, recipientKey} from './reviewWorkspace';
// Pure selection helpers; a browser-based plan is not a dispatch authorization.
export const getGroups = (rows,corrections=new Set())=>{
 const groups=new Map();
 for(const row of rows){
  const s=row.eligibility?.snapshot;
 const preliminary=row.eligibility?.planning_only===true;
 const agent=String(s?.agent_name||'').trim();
 const key=preliminary?(agent?'agent:'+String(row.agent_id??'unmapped')+':'+agent.toLocaleLowerCase('de-DE'):''):recipientKey(row);
  if(!key||!s||!s.review_url)continue;
  const previouslySent=row.previously_sent===true||String(row.status||'').toLowerCase()==='eingereicht'||['reported_sent','completed'].includes(row.eligibility?.status);
  if(!previouslySent&&['storno','privat','erstattet'].includes(String(row.status||'').toLowerCase()))continue;
  if(!groups.has(key))groups.set(key,{key,agent:s.agent_name||'Ohne Namen',agentPk:s.agent_pk,target:preliminary?'Ziel wird vor Versand geprüft':s.target_name,targetId:preliminary?'':s.target_id,type:s.target_type,ready:[],sent:[],blocked:0});
  if(previouslySent)groups.get(key).sent.push(row);
  else if(!correctionRequired(row,corrections)&&(preliminary||canBulkDispatch(row,corrections)))groups.get(key).ready.push(row);
  else groups.get(key).blocked++;
 }
 return [...groups.values()].sort((a,b)=>String(a.agent).localeCompare(String(b.agent),'de')||String(a.targetId).localeCompare(String(b.targetId)));
};
export function makeSelection(groups,agentKeys,excludedIds=new Set()){
 return groups.filter(g=>agentKeys.has(g.key)).flatMap(g=>g.ready.filter(r=>!excludedIds.has(Number(r.id))).map(r=>Number(r.id)));
}
